const megaemitters = [{
        'lat': '41.607175',
        'lng': '-87.337602',
        'name': 'U .S. STEEL CO. GARY WORKS',
    },
    {
        'lat': '41.622735',
        'lng': '-87.116998',
        'name': 'ARCELORMITTAL BURNS HARBOR, INC',
    },
    {
        'lat': '41.652604',
        'lng': '-87.457297',
        'name': 'INDIANA HARBOR EAST ',
    },
    {
        'lat': '41.218647',
        'lng': '-87.023819',
        'name': 'NIPSCO - R.M. SCHAHFER GENERATING STATION',
    },
    {
        'lat': '41.708132',
        'lng': '-87.521315',
        'name': 'DOMINION RESOURCES - STATE LINE ENERGY, LLC',
    },
    {
        'lat': '41.720852',
        'lng': '-86.906901',
        'name': 'NIPSCO - MICHIGAN CITY GENERATING STATION ',
    },
    {
        'lat': '41.662580',
        'lng': '-87.482625',
        'name': 'BP PRODUCTS NORTH AMERICA, INC.',
    },
    {
        'lat': '41.679816',
        'lng': '-87.417311',
        'name': 'COKENERGY, INC.',
    },
    {
        'lat': '41.655465',
        'lng': '-87.450172',
        'name': 'ARCELORMITTAL INDIANA HARBOR, INC.',
    }
];

export default megaemitters;
